import { render, staticRenderFns } from "./ReservationPolicySummary.vue?vue&type=template&id=5db4029b&scoped=true"
import script from "./ReservationPolicySummary.vue?vue&type=script&lang=js"
export * from "./ReservationPolicySummary.vue?vue&type=script&lang=js"
import style0 from "./ReservationPolicySummary.vue?vue&type=style&index=0&id=5db4029b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db4029b",
  null
  
)

export default component.exports